<form *ngIf="!!form" class="form d-flex">
  <div *ngIf="showSidebarCollapsedBtn" class="form-collapsed">
    <xux-expand-collapse-icon [collapsed]="!expandSidebar"  (onCollapsed)="expandCollapseSidebar($event)"></xux-expand-collapse-icon>
  </div>
  <div data-e2e-id="form-content" class="row form-content flex-1">
    <div *ngIf="bannerText" class="banner-wrapper col-sm-12">
      <p class="banner">{{ bannerText | translate }}</p>
    </div>

    <!-- sidebar container -->
    <div
      *ngIf="expandSidebar"
      data-e2e-id="xux-sidebar" class="col-sm-2 xux-sidebar scroll-area xux-sidebar-scroll scroll-bg-none"
    >
      <ul class="xux-side-nav hidden-mobile">
        <ng-template ngFor let-group [ngForOf]="groups" let-groupIndex="index">
          <li
            *ngIf="!(group.hiddenObs && (group.hiddenObs | async))"
            [class.has-divider]="group?.groupClass === 'has-divider'"
          >
            <span *ngIf="group?.relatedChanges?.length" class="bullet-circle {{ group.bulletColor }}"></span>
            <a
              class="xux-side-nav-link"
              [class.active]="isActiveTab(groupIndex)"
              (click)="setActiveTabIndex(groupIndex)"
              data-e2e-id="form-nav-link-desktop"
            >
              {{ group.titleObs | async | translate }}
            </a>
          </li>
        </ng-template>
      </ul>

      <div class="xux-side-nav-mobile hidden-desktop">
        <div data-e2e-id="xux-dropdown" class="xux-dropdown dropdown">
          <button
            data-e2e-id="dropdown-button"
            type="button"
            class="btn btn-default"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ activeTabName | translate}}
            <i class="glyphicon glyphicon-menu-down"></i>
          </button>

          <ul data-e2e-id="dropdown-menu" class="dropdown-menu">
            <ng-template ngFor let-group [ngForOf]="groups" let-groupIndex="index">
              <li *ngIf="!(group.hiddenObs && (group.hiddenObs | async))">
                <a
                  data-e2e-id="form-nav-link-mobile"
                  [class.active]="isActiveTab(groupIndex)"
                  (click)="setActiveTabIndex(groupIndex)"
                >
                  {{ group.name | translate}}
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>

      <xux-sidebar-details
        *ngIf="documentSidebarDetails"
        [sidebarInfo]="documentSidebarDetails"
        data-e2e-id="xux-sidebar-details"
        class="hidden-mobile"
      >
      </xux-sidebar-details>
    </div>
    <!-- sidebar container END -->

    <!-- pages container -->
    <div
      data-e2e-id="xux-form-content"
      class="col-sm-10 xux-form-content"
      [ngClass]="{'no-sidebar': !expandSidebar}"
    >
      <div
        data-e2e-id="form-scroll-area"
        class="scroll-area form-scroll-area"
        [ngClass]="{'no-sidebar': !expandSidebar, 'sidebar-collapsed': !expandSidebar && showSidebarCollapsedBtn}"
        #scrollArea
      >
        <xvi-alert-box *ngIf="errors" [errors]="errors"></xvi-alert-box>
        <div class="row" [class.d-flex]="enableRightExpand">
          <div class="left-form" [class.flex-1]="enableRightExpand">
            <ng-template ngFor let-group [ngForOf]="groups" let-groupIndex="index">
              <xvi-schema-form-group
                *ngIf="!(group.hiddenObs && (group.hiddenObs | async))"
                [group]="group"
                [dynamicWidgetsMap]="dynamicWidgetsMap"
                [class.hidden]="!isActiveTab(groupIndex)"
                [defaultWidgetFamily]="defaultWidgetFamily"
                [attr.data-group-index]="groupIndex"
                data-e2e-id="form-page"
                #shemaFormGroup
              ></xvi-schema-form-group>
            </ng-template>
          </div>

          <div *ngIf="enableRightExpand && rightFormsConfig?.length > 0" class="right-form" [class.expanded]="rightFormExpanded">
            <ng-template ngFor let-rightFormConfig [ngForOf]="rightFormsConfig">
              <xvi-common-form
                [expanded$]="rightExpanded$"
                [disabledFunc]="disabledFunc"
                [formConfig]="rightFormConfig"
                [dynamicWidgetsMap]="dynamicWidgetsMap"
                [defaultWidgetFamily]="defaultWidgetFamily"
                [attr.data-e2e-id]="'right-form-page-' + rightFormConfig.formKey"
                (onFormAction)="onRightFormAction.emit($event)"
                (onExpandChanged)="onRightFormExpandChanged($event)"
                [ngClass]="rightFormConfig?.class"
              ></xvi-common-form>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <!-- pages container END -->
    <xux-loader-small *ngIf="busy"></xux-loader-small>
  </div>
</form>
